import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Table, IconButton, Dialog, Button } from 'react-toolbox'
import CSSModules from 'react-css-modules'
import _ from 'lodash'

import CpuConfigItem from './CpuConfigItem'

import styles from './styles.scss'

class CpuConfig extends Component {
  onAddPart(partConfig = {}) {
    return () => {
      this.props.onTogglePopup()
      this.props.onUpdateCurConfig(partConfig)
    }
  }

  render() {
    const {
      sources,
      values,
      filterStatus,
      initFilters,
      onDeletePart,
      onModelNameChange,
      showAddCpuButton
    } = this.props
    const cpuConfigItem =
      <CpuConfigItem
        sources={sources}
        curPart={values}
        filterStatus={filterStatus}
        initFilters={initFilters}
        onDeletePart={onDeletePart}
        onModelNameChange={onModelNameChange}
      />

    return <div>
      <h4 styleName='configTitle'>CPU</h4>
      { cpuConfigItem }
      { showAddCpuButton && <Button
        icon='add'
        label='ADD CPU'
        flat
        primary
        onClick={ this.onAddPart() }
        styleName='universeAddBtn'
        theme={styles}
      />}
    </div>
  }
}

CpuConfig.propTypes = {
  values: PropTypes.array.isRequired,
  togglePopup: PropTypes.bool.isRequired,

  onTogglePopup: PropTypes.func.isRequired,
  onDeletePart: PropTypes.func.isRequired,
  onUpdateCurConfig: PropTypes.func.isRequired,
}

export default CSSModules(CpuConfig, styles)
